// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback } from "react";
import { EVoterSigningPolicy, isUndefined, } from "@sequentech/ui-core";
import { provideBallotService } from "../services/BallotService";
import { isReceivedAtReview } from "./useReceiveBallot";
import { setBallotSelection } from "../store/ballotSelections/ballotSelectionsSlice";
import { setAuditableBallot } from "../store/auditableBallots/auditableBallotsSlice";
import { useAppDispatch } from "../store/hooks";
export var useEncryptBallotForReview = function () {
    var dispatch = useAppDispatch();
    var _a = provideBallotService(), encryptBallotSelection = _a.encryptBallotSelection, encryptMultiBallotSelection = _a.encryptMultiBallotSelection, decodeAuditableBallot = _a.decodeAuditableBallot, decodeAuditableMultiBallot = _a.decodeAuditableMultiBallot, signHashableMultiBallot = _a.signHashableMultiBallot, signHashableBallot = _a.signHashableBallot, hashMultiBallot = _a.hashMultiBallot, hashBallot = _a.hashBallot;
    var encryptAndStoreBallot = useCallback(function (ballotStyle, selectionState, isMultiContest) {
        var _a;
        try {
            // The ballot box receives only ballots their voter has signed.
            var doSignBallot = ((_a = ballotStyle.ballot_eml.election_event_presentation) === null || _a === void 0 ? void 0 : _a.voter_signing_policy) ===
                EVoterSigningPolicy.WITH_SIGNATURE || isReceivedAtReview(ballotStyle);
            var auditableBallot = isMultiContest
                ? encryptMultiBallotSelection(selectionState, ballotStyle.ballot_eml)
                : encryptBallotSelection(selectionState, ballotStyle.ballot_eml);
            var ballotId = isMultiContest
                ? hashMultiBallot(auditableBallot)
                : hashBallot(auditableBallot);
            if (doSignBallot) {
                var signedContent = isMultiContest
                    ? signHashableMultiBallot(ballotId, ballotStyle.election_id, auditableBallot)
                    : signHashableBallot(ballotId, ballotStyle.election_id, auditableBallot);
                auditableBallot.voter_signing_pk = signedContent === null || signedContent === void 0 ? void 0 : signedContent.public_key;
                auditableBallot.voter_ballot_signature = signedContent === null || signedContent === void 0 ? void 0 : signedContent.signature;
            }
            var decodedSelectionState = isMultiContest
                ? decodeAuditableMultiBallot(auditableBallot)
                : decodeAuditableBallot(auditableBallot);
            var isBlankBallot = Boolean((decodedSelectionState === null || decodedSelectionState === void 0 ? void 0 : decodedSelectionState.length) &&
                decodedSelectionState.every(function (contest) { return contest.is_blank_ballot; }));
            dispatch(setAuditableBallot({
                electionId: ballotStyle.election_id,
                auditableBallot: auditableBallot,
                isBlankBallot: isBlankBallot,
            }));
            if (!isUndefined(decodedSelectionState) && decodedSelectionState !== null) {
                dispatch(setBallotSelection({
                    ballotStyle: ballotStyle,
                    ballotSelection: decodedSelectionState,
                }));
            }
            return true;
        }
        catch (error) {
            console.error("Failed to encrypt ballot for review:", error);
            return false;
        }
    }, [
        dispatch,
        encryptBallotSelection,
        encryptMultiBallotSelection,
        decodeAuditableBallot,
        decodeAuditableMultiBallot,
        signHashableMultiBallot,
        signHashableBallot,
        hashMultiBallot,
        hashBallot,
    ]);
    return { encryptAndStoreBallot: encryptAndStoreBallot };
};
